import type { ReactNode } from 'react';

/* Faixa de métricas-resumo no topo de uma tela de detalhe (ADR-0707). Condensa contagens/estado
   derivados dos dados já carregados (orgs, devices, licenses, membros, assentos, stats…) numa linha
   escaneável — resolve o padrão "detalhe raso" em que tudo ficava escondido nas abas. */
export interface SummaryMetric {
  readonly label: string;
  readonly value: ReactNode;
  readonly hint?: string;
}

export function SummaryMetrics({ items }: { readonly items: readonly SummaryMetric[] }) {
  if (items.length === 0) return null;
  return (
    <dl className="flex flex-wrap gap-x-8 gap-y-3 rounded-lg border border-border bg-card px-4 py-3">
      {items.map((m) => (
        <div key={m.label} className="min-w-24">
          <dt className="text-xs text-muted-foreground">{m.label}</dt>
          <dd className="font-semibold text-foreground text-lg tabular-nums">{m.value}</dd>
          {m.hint !== undefined && <dd className="text-muted-foreground text-xs">{m.hint}</dd>}
        </div>
      ))}
    </dl>
  );
}
